import { render, staticRenderFns } from "./UnionForm.vue?vue&type=template&id=6b968e2a&"
import script from "./UnionForm.vue?vue&type=script&lang=js&"
export * from "./UnionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports